import axios from 'axios';
import { useToast } from '@/composables/use-toast.js';
import { useStorage } from '@/composables/use-storage.js';
const { addToast } = useToast();
const { userAuthToken } = useStorage();

const cacheBaseUrl = '/api/cache';
const baseURL = process.env.VUE_APP_BACKEND_URL || 'http://localhost:3000';

const getAuthHeaders = () => {
    const token = userAuthToken.value;
    return {
        headers: {
        'Authorization': `Bearer ${token}`
        },
        withCredentials: true
    };
};

export const getRecoverySessionData = async ({ key, id }) => {
    try {
        const response = await axios.get(`${cacheBaseUrl}/recovery_session_data?key=${key}&id=${id}`, getAuthHeaders());
        return response.data;
    } catch (error) {
        console.error('Error getting recovery session data:', error);
        return null;
    }
}

export const saveRecoverySessionData = async (data) => {
    try {
        const response = await axios.post(`${cacheBaseUrl}/recovery_session_data`, data, getAuthHeaders());
        return response.data;
    } catch (error) {
        console.error('Error saving recovery session data:', error);
        return null;
    }
}
